import React, { FunctionComponent, useCallback, useEffect } from 'react'
import classes from './CookieDisclaimer.module.scss'
import { Button } from '../Button'
import { ImpressumModal } from '../Footer/ImpressumModal'
import { PrivacyStatementModal } from '../Footer/PrivacyStatementModal'
import { LanguageChange } from '../LanguageChange'
import { useTranslation } from 'react-i18next'
import { CookieModal } from './CookieModal'

export const CookieDisclaimer: FunctionComponent<any> = ({ accept }) => {
  const { t } = useTranslation()

  const applyStorage = useCallback(() => {
    accept(true)
    sessionStorage.setItem('acceptCookies', 'true')
  }, [accept])

  useEffect(() => {
    const listener = (event: any) => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        event.preventDefault()
        applyStorage()
      }
    }
    document.addEventListener('keydown', listener)
    return () => {
      document.removeEventListener('keydown', listener)
    }
  }, [applyStorage])

  return (
    <div className={classes.wrapper}>
      <div className={classes.overlay}></div>
      <div className={classes.container}>
        <LanguageChange />

        <div>
          <h4>{t('cookieDisclaimer.headline')}</h4>
          <p>{t('cookieDisclaimer.description.0')} </p>
          <p style={{ display: 'inline' }}>
            {t('cookieDisclaimer.description.1')}
          </p>{' '}
          <CookieModal />
        </div>
        <div className={classes.button_wrapper}>
          <Button onClick={() => applyStorage()} id="e2e-accept-btn">
            {t('cookieDisclaimer.accept')}
          </Button>
        </div>
        <div className={classes.footer}>
          <ImpressumModal />
          <PrivacyStatementModal />
        </div>
      </div>
    </div>
  )
}
